const getDataLayer = () => {
  if (window.dataLayer) {
    return window.dataLayer;
  }
  return null;
};

export default getDataLayer;
